import { memo } from "react"
import ApiError from "../../components/ApiError"
import { useGlobalSettings } from "../../hooks/useGlobalSettings"
import SettingCard from "./components/SettingCard"
import SettingCardSkeleton from "./components/SettingCardSkeleton"
import ExperimentsPanel from "./components/ExperimentsPanel"

const Settings = () => {
  const { data: settings, isLoading, isError, error } = useGlobalSettings()

  return (
    <div className="mx-auto w-full md:max-w-[100%] 2xl:max-w-[80%] px-4 py-4">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold text-primary">Settings</h1>
        <p className="mt-1 text-sm text-gray-500">
          Global configuration shared by the dashboard and the services that
          read from it. Changes take effect immediately and are recorded.
        </p>
      </header>

      {isError ? (
        <ApiError axiosError={error} />
      ) : (
        <div className="flex flex-col gap-5">
          {isLoading ? (
            <SettingCardSkeleton />
          ) : (
            settings.map((setting) => (
              <SettingCard key={setting.key} setting={setting} />
            ))
          )}
          <ExperimentsPanel />
        </div>
      )}
    </div>
  )
}

export default memo(Settings)
